import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getStore, removeStore, setStore } from './utils/util'
import { getAswAppUserToken } from '@/api/common'
import store from '@/store'

NProgress.configure({ showSpinner: false })

const whiteList = ['/index', '/secondCategory', '/login', '/beauty/login', '/register', '/agreement']
let isProcessingAuth = false;  // 添加标记

const SERVICE_CONFIG = {
  SERVICE: 'serviceCategoryL1Code',
  SERVICE_CODE: 'specifySerCategoryL1Code'
}

// 获取当前服务参数
const getServiceQuery = () => {
  const serviceParam = getStore('serviceParam')
  const serviceValue = getStore('serviceValue')
  const serviceCode = getStore('serviceCode')
  const serviceCategoryL2Code = getStore('serviceCategoryL2Code')
  const specifySerCategoryL2Code = getStore('specifySerCategoryL2Code')
  const specialService = getStore('specialService')
  const storeCode = getStore('storeCode')
  
  const query = {}

  if (serviceParam && serviceValue) {
    query[serviceParam] = serviceValue
  }
  if (serviceCode) {
    query.serviceCode = serviceCode
  }
  if (serviceCategoryL2Code) {
    query.serviceCategoryL2Code = serviceCategoryL2Code
  }

  if (specifySerCategoryL2Code) {
    query.specifySerCategoryL2Code = specifySerCategoryL2Code
  }

  if (specialService) {
    query.specialService = specialService
  }
  if (storeCode) {
    query.storeCode = storeCode
  }

  const refValue = getStore('ref')
  if (refValue) {
    query.ref = refValue
  }
  return query
}

// 添加服务参数到路由配置
const addServiceParams = (routeConfig) => {
  const serviceQuery = getServiceQuery()

  if (typeof routeConfig === 'string') {
    return {
      path: routeConfig,
      query: serviceQuery
    }
  }

  return {
    ...routeConfig,
    query: {
      ...serviceQuery,
      ...(routeConfig.query || {})
    }
  }
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  console.log('Router guard triggered:', { to: to.path, from: from.path });

  // 处理服务参数
  const { serviceCategoryL1Code, specifySerCategoryL1Code, serviceCode, serviceCategoryL2Code, specifySerCategoryL2Code, specialService,storeCode, ref } = to.query

  // 如果 URL 中没有服务参数，但存储中有 清除缓存
  if (!serviceCategoryL1Code && !specifySerCategoryL1Code) {
    const storedService = getStore('serviceParam')
    const storedValue = getStore('serviceValue')

    storedService && removeStore('serviceParam')
    storedValue && removeStore('serviceValue')
  }

  if (!serviceCode) {
    getStore('serviceCode') && removeStore('serviceCode')
  }

  if (!serviceCategoryL2Code) {
    getStore('serviceCategoryL2Code') && removeStore('serviceCategoryL2Code')
  }

  if (!specifySerCategoryL2Code) {
    getStore('specifySerCategoryL2Code') && removeStore('specifySerCategoryL2Code')
  }

  if (!specialService) {
    getStore('specialService') && removeStore('specialService')
  }

  if(!storeCode){
    getStore('storeCode') && removeStore('storeCode')
  }

  // 邀请码 ref：URL 里没有就清除库存，防止上次带 ref 的访问未下单就离开、
  // 残留的旧 ref 之后被 getServiceQuery/mixin 回填到 URL 污染新预约。
  if (!ref) {
    getStore('ref') && removeStore('ref')
  }

  // 如果 URL 中有服务参数，存储它
  if (serviceCategoryL1Code) {
    setStore('serviceParam', SERVICE_CONFIG.SERVICE)
    setStore('serviceValue', serviceCategoryL1Code)
  } else if (specifySerCategoryL1Code) {
    setStore('serviceParam', SERVICE_CONFIG.SERVICE_CODE)
    setStore('serviceValue', specifySerCategoryL1Code)
  }

  if (serviceCode) setStore('serviceCode', serviceCode)
  if (serviceCategoryL2Code) setStore('serviceCategoryL2Code', serviceCategoryL2Code)
  if (specifySerCategoryL2Code) setStore('specifySerCategoryL2Code', specifySerCategoryL2Code)
  if (specialService) setStore('specialService', specialService)
  if (storeCode) setStore('storeCode', storeCode)
  if (ref) setStore('ref', ref)

  // 处理authToken
  const { search, pathname } = window.location
  const urlParams = new URLSearchParams(search);
  const authToken = urlParams.get('authToken');

  if (authToken && pathname.startsWith("/beauty") && !isProcessingAuth) {
    isProcessingAuth = true;  // 设置标记
    try {
      const res = await getAswAppUserToken({ authKey: authToken });
      if (res.data) {
        const { token, tokenHead } = res.data
        setStore("token", token);
        setStore("tokenHead", tokenHead);

        // 获取用户信息
        try {
          await store.dispatch('getUserInfo')
          next(addServiceParams({ path: '/beauty/home', replace: true }));
        } catch (error) {
          console.error('获取用户信息失败:', error);
          next(addServiceParams('/beauty/login'));
        }
        return;
      }
    } catch (error) {
      console.error('Token获取失败:', error);
      next(addServiceParams('/beauty/login'))
      return
    } finally {
      isProcessingAuth = false;  // 重置标记
    }
  }

  const token = getStore('token')

  // 已登录用户处理
  if (token) {
    if (to.path === '/beauty/login') {
      next(addServiceParams('/beauty/home'))
      return
    } else if (to.path === '/login' || to.path === '/index') {
      next(addServiceParams('/home')) // 添加服务参数到重定向
      return
    }
    next()
    return
  }

  // 白名单处理
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  // 特殊处理 /recordDetail 页面
  if (to.path === '/recordDetail' && to.query.orderId) {
    const redirect = encodeURIComponent(to.fullPath);
    next(`/login?redirect=${redirect}`);
    return;
  }

  // 特殊处理 /beauty/recordDetail 页面
  if (to.path === '/beauty/recordDetail' && to.query.orderId) {
    const redirect = encodeURIComponent(to.fullPath);
    next(`/beauty/login?redirect=${redirect}`);
    return;
  }

  if (from.path.includes('/beauty') || to.path.includes('/beauty')) {
    next(addServiceParams('/beauty/login'))
    return
  }

  if (serviceCategoryL1Code || specifySerCategoryL1Code) {
    next(addServiceParams('/login'))
    return
  }
  next(addServiceParams('/index'))
})

router.afterEach(() => {
  NProgress.done()
})